import React, { ReactNode } from "react";
import { Elements, RecurlyProvider } from "@recurly/react-recurly";
import { REQUIRED_FIELDS } from "../../contracts/recurly-api/consts";
import CONFIG from "../../core/consts/config";

interface propsType {
  children?: ReactNode;
}

export function RecurlyWrapper(props: propsType) {
  return (
    <RecurlyProvider
      publicKey={CONFIG.RECURLY_PUBLIC_KEY || ""}
      required={REQUIRED_FIELDS}
    >
      <Elements>{props.children}</Elements>
    </RecurlyProvider>
  );
}

export default RecurlyWrapper;
